var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClass},[(_vm.type == 'dots')?_c('div',[_vm._t("default"),_c('span',{class:{ 'loader-dots': _vm.loading }})],2):_c('div',{staticClass:"sub-container"},[_c('i',{staticClass:"asknicely-icon-loader_static"}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }